import { useNavigate } from "react-router";
import { ReactComponent as NoConnectionSvg } from "src/assets/icons/no-internet.svg";
import Button from "../button";
import Layout from "../layout";
import Typography from "../typography";

function NoInternetConnection() {
	// { setShowErrorComponent }: { setShowErrorComponent: (data: boolean) => void }
	const navigate = useNavigate();
	return (
		<Layout className="flex h-full flex-1 flex-col items-center justify-center" showHeader={false}>
			<div className="flex flex-1 flex-col items-center justify-center">
				<NoConnectionSvg />

				<Typography className="mx-auto w-2/3 text-neutral-600" variant="bodyXM">
					Slow or no internet connection. Please check your internet settings.
				</Typography>

				<div className="mt-4 flex justify-evenly space-x-4">
					<Button className="bg-secondary text-black" onClick={() => navigate(0)}>
						Try again
					</Button>
					{/* <Button onClick={() => setShowErrorComponent(false)} className="bg-secondary text-black">
            Go Offline
          </Button> */}
				</div>
			</div>
		</Layout>
	);
}

export default NoInternetConnection;
